export enum ApplicationProgressStep {
    APPLICATION_START = 0,
    APPLICATION_SUBMITTED = 1,
    CONTRACT_PREPARATION = 2,
    CONTRACT_SIGNING = 3,
    UNDERWRITING = 4,
    ACCEPT_PAYMENTS = 5
}
